import styled from "styled-components";

export const StyledContainer = styled.div`
    width: 100%;
  height: 100%;

  overflow-x: auto;
  overflow-y: auto;

  table {
    min-width: max-content;
    border-spacing: 0;
  }
  margin-top: 20px;
`;

export const StatusPill = styled.span<{ $success: boolean }>`
  padding: 4px 10px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  background: ${({ $success }) => ($success ? "#d4ffdf" : "#ffe0e0")};
  color: ${({ $success }) => ($success ? "#0b7a28" : "#a30000")};
`;

export const ErrorState = styled.div`
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  text-align: center;
  color: #4d5a5e;

  h3 {
    margin-bottom: 8px;
    font-size: 16px;
    font-weight: 600;
  }

  p {
    font-size: 13px;
    line-height: 1.4;
    max-width: 360px;
  }
`;

export const ErrorSummary = styled.div`
  background: #fff5f5;
  border: 1px solid #ffcccc;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;
`;

export const ErrorSummaryHeader = styled.div`
  display: flex;
  align-items: center;
  color: #cc0000;
  font-size: 14px;
  margin-bottom: 12px;
  font-weight: 500;
`;

export const ErrorList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 300px;
  overflow-y: auto;
`;

export const ErrorItem = styled.div`
  background: white;
  border: 1px solid #ffdddd;
  border-radius: 6px;
  padding: 10px 12px;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const ErrorItemLabel = styled.span`
  font-size: 12px;
  color: #666;
  font-weight: 500;
`;

export const ErrorItemMessage = styled.span`
  font-size: 13px;
  color: #cc0000;
`;
